import { useTranslation } from "react-i18next";

import { useProfileStore } from "../../../store/useProfileStore";
import { useRatesStore } from "../../../store/useRatesStore";
import { useErrorFieldStore } from "../../../store/useErrorsFieldsStore";
import React from "react";
import OldSlider from "../../../components/common/Slider/OldSlider";

export function ServiceTypeTwo() {
    const { t, i18n } = useTranslation();
    const language = i18n.language;

    const [errorField, setErrorField] = useErrorFieldStore((state) => [
        state.errorField,
        state.setErrorField,
    ]);

  const { detail } = useProfileStore();

  const { generalRate, setGeneralRate } = useRatesStore();
  return (
    <div className="special_education big">
      <h2 className="border">
        <img src="./images/special_education.svg" /> {t("education-teacher")}
      </h2>
      <div className="form_group full">
        <label>
          {t("Rate per hour")} {language === 'sr' ? "(RSD)" : "(USD)"}
          <span className={errorField.nanyperhrrate && errorField.nanyperhrrate !== "" ? "starred" : ""}>
            *
          </span>
        </label>
          <OldSlider rate={generalRate} setRate={setGeneralRate} serbian={language === 'sr'}/>
          <span className="price">
          {language === 'sr'
              ? generalRate.min * 100 + " - " + generalRate.max * 100 + (generalRate.max === 60 ? "+" : "")
              : generalRate.min + " - " + generalRate.max + (generalRate.max === 60 ? "+" : "")}
        </span>
      </div>
    </div>
  )
      ;
}
